'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ku_IQ = require('../locale/ku_IQ');

var _ku_IQ2 = _interopRequireDefault(_ku_IQ);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _ku_IQ2['default'];